import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Snackbar,
  Typography,
} from '@mui/material'
import React, { useRef } from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import { moduleType } from '../../constants/modules'
import questionImage from '../../assets/images/soal.svg'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { RuleDescription, RuleHeader, RuleItem } from '../../components/rulesElements/elements'
import RuleInfoItem from '../../components/rulesElements/RuleInfoItem'
import CircleIcon from '@mui/icons-material/Circle'
import { BaseService } from '../../services/BaseService'
import { useQuery } from 'react-query'
import SkeletonLoading from '../../components/SkeletonLoading'
import { useModule } from '../../context/ModuleContext/ModuleContext'
import { REMOVE_MODULE, START_QUESTION } from '../../reducers/reducesTypes'
import { removeLocalStorageData } from '../../utils/storage/storage'
import { useGetUser } from '../../hooks/useGetUser'
import { useCameraContext } from '../../context/CameraContext/CameraContext'
import { useGeolocationContext } from '../../context/GeolocationContext/GeolocationContext'
import { useLogging } from '../../context/LoggingContext/LoggingContext'
import DobModal from '../../components/Modal/DobModal'
import { extractDob, isDobValid } from '../../utils/dobValidation'

// import LoaderHomePage from '../../components/Loader/LoaderHomePage'

async function fetchRules(id) {
  const params = {
    id: id,
  }

  const service = new BaseService('/m_rules_2')
  const res = await service.getRules(params)
  return res.data
}
async function fetchHistory(userId) {
  const service = new BaseService('/m_history_2')
  const res = await service.getHistory({
    id_user: userId,
  })

  return res.data
}

const RulesPage = () => {
  const { modules, dispatch } = useModule()
  const { id } = useParams()
  const { user } = useGetUser()
  const [showModal, setShowModal] = React.useState(false)
  const { permissionGranted: cameraGranted, requestCameraPermission } = useCameraContext()
  const { permissionGranted: locationGranted, requestLocation } = useGeolocationContext()
  const [showWarning, setShowWarning] = React.useState(false)
  const [canProceed, setCanProceed] = React.useState(false)
  const { addLog } = useLogging()

  // const ua = navigator.userAgent
  // const isIOS = /iPhone|iPad|iPod/i.test(ua)

  // 🔥 STRICT PERMISSION (No more guessing)
  const safeCameraGranted = cameraGranted === true
  const safeLocationGranted = locationGranted === true

  const isStartingRef = useRef(false)

  React.useEffect(() => {
    if (showWarning) {
      setCanProceed(false)
      const timer = setTimeout(() => setCanProceed(true), 3000) // ⏱️ aktif setelah 3 detik
      return () => clearTimeout(timer)
    }
  }, [showWarning])

  const { isLoading, data } = useQuery({
    queryKey: ['rules', id],
    queryFn: async () => await fetchRules(id),
  })

  const { data: dataHistory } = useQuery({
    queryKey: ['rules-history', id],
    queryFn: async () => await fetchHistory(user.id),
  })

  const isIST = ['intelligenz-struktur-test (ist)', 'ist'].includes(
    modules.nama_modul?.trim().toLowerCase(),
  )

  const isKraep = ['kraepelin test', 'kraepelin'].includes(modules.nama_modul?.trim().toLowerCase())

  const [showDobModal, setShowDobModal] = React.useState(false)
  const [currentDob, setCurrentDob] = React.useState(null)

  const { data: dataDob, refetch: refetchDob } = useQuery({
    queryKey: ['check-dob-rules', user?.id],
    queryFn: async () => {
      const service = new BaseService('/m_dob')
      return await service.getDob({ id_user: user?.id })
    },
    enabled: !!isIST && !!user?.id,
  })

  React.useEffect(() => {
    if (isIST && dataDob !== undefined) {
      const extracted = extractDob(dataDob)
      setCurrentDob(extracted)
      if (!isDobValid(extracted)) {
        setShowDobModal(true)
      } else {
        setShowDobModal(false)
      }
    }
  }, [isIST, dataDob])

  const [dobAlert, setDobAlert] = React.useState({
    open: false,
    message: '',
    severity: 'success',
  })

  const handleDobSuccess = (newDob, msg) => {
    setCurrentDob(newDob)
    setShowDobModal(false)
    setDobAlert({
      open: true,
      message: msg || 'Tanggal lahir berhasil disimpan!',
      severity: 'success',
    })
    refetchDob()
  }

  const checkDoneTask = dataHistory?.data?.filter((h) => h.id === id).length > 0

  if (isIST && checkDoneTask) {
    removeLocalStorageData('questionIst')
    removeLocalStorageData('camera_capture_log')
  }

  if (isKraep && checkDoneTask) {
    removeLocalStorageData('questionKraep')
    removeLocalStorageData('camera_capture_log')
  }

  if (Object.keys(modules).length < 1) {
    return <Navigate to="/home" replace />
  }
  // if (!user) {
  //   window.location.reload()
  //   return <LoaderHomePage />
  // }
  // function beginQuestion() {
  //   dispatch({
  //     type: START_QUESTION,
  //   })
  //   // navigate(`/question/${id}`)

  //   addLog(user.id, id, 'Mulai mengerjakan test')

  //   const newTab = window.open(`${process.env.REACT_APP_BASE_NAME}/question/${id}`)
  //   if (newTab) {
  //     newTab.focus()
  //   }
  //   setTimeout(() => {
  //     window.close()
  //   }, 1000)
  // }

  // async function beginQuestion() {
  //   dispatch({ type: START_QUESTION })

  //   try {
  //     const ua = navigator.userAgent

  //     await Promise.all([
  //       addLog(user.id, id, 'Mulai mengerjakan test'),
  //       addLog(
  //         user.id,
  //         id,
  //         JSON.stringify({
  //           event: 'start_test',
  //           camera: {
  //             required_by_admin: !!modules?.rules?.camera,
  //             granted_by_user: !!cameraGranted,
  //             status: cameraGranted ? 'ok' : 'fail',
  //           },
  //           geolocation: {
  //             required_by_admin: !!modules?.rules?.geo,
  //             granted_by_user: !!locationGranted,
  //             status: locationGranted ? 'ok' : 'fail',
  //           },
  //           device: {
  //             browser: /Chrome/.test(ua) ? 'chrome' : 'not-chrome',
  //             platform: /Android/.test(ua) ? 'android' : /iPhone|iPad/.test(ua) ? 'ios' : 'desktop',
  //           },
  //         }),
  //       ),
  //     ])

  //     await new Promise((r) => setTimeout(r, 600))

  //     // if (res1?.status === 'success' && res2?.status === 'success') {
  //     // new tab version
  //     // const newTab = window.open(`${process.env.REACT_APP_BASE_NAME}/question/${id}`)
  //     window.open(`${process.env.REACT_APP_BASE_NAME}/question/${id}`)
  //     // if (newTab) newTab.focus()

  //     // setTimeout(() => {
  //     //   // window.close()
  //     // }, 1000)

  //     // // without new tab version
  //     // window.location.href = `${process.env.REACT_APP_BASE_NAME}/question/${id}`
  //     // }
  //   } catch (err) {
  //     console.error('Gagal kirim log:', err)
  //   }
  // }

  async function beginQuestion() {
    if (isStartingRef.current) return
    isStartingRef.current = true

    dispatch({ type: START_QUESTION })

    try {
      const res = await addLog(user.id, id, 'Mulai mengerjakan test')
      if (res?.status === 'success') {
        window.location.href = `${process.env.REACT_APP_BASE_NAME}/question/${id}`
      } else {
        isStartingRef.current = false
      }
    } catch (err) {
      console.error('Gagal kirim log:', err)
      isStartingRef.current = false
    }
  }

  function removeModule() {
    dispatch({
      type: REMOVE_MODULE,
    })
    removeLocalStorageData('module')
  }

  return (
    <Box
      mx="-1rem"
      height={'100%'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: ({ palette }) => palette[moduleType[modules.tipe_modul]]['light'],
        position: 'relative',
      }}
    >
      <Box p={1} position={'fixed'} zIndex={99}>
        <Link to={'../'} onClick={removeModule}>
          <IconButton sx={{ borderRadius: '10px' }}>
            <ArrowBackIcon />
          </IconButton>
        </Link>
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          maxHeight: '180px',
          minHeight: '170px',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '260px',
            height: '100%',
            backgroundAttachment: 'fixed',
            backgroundSize: '50% 20%',
            backgroundImage: `url(${questionImage})`,
            backgroundPosition: 'top',
            backgroundRepeat: 'no-repeat',
          }}
        ></Box>
      </Box>
      <Box
        p={'1rem'}
        height={'100%'}
        sx={{
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
          backgroundColor: ({ palette }) => palette.background.default,
          paddingBottom: '60px',
        }}
      >
        <Box
          width={'100%'}
          sx={{
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            backgroundColor: ({ palette }) => palette.background.default,
          }}
        >
          <Box
            py={2}
            bgcolor={({ palette }) => palette['background'].default}
            position={'sticky'}
            top={0}
            sx={{
              borderTopLeftRadius: '20px',
              borderTopRightRadius: '20px',
              zIndex: 2,
            }}
          >
            <RuleHeader>{modules.nama_modul}</RuleHeader>
          </Box>
          <Divider />
          <Box>
            <RuleInfoItem
              timer={modules.waktu_pengerjaan}
              amount={modules.jumlah_soal}
              type={modules.tipe_modul}
            />
            <Box width={'100%'} mb={3}>
              <Typography fontWeight={700}>Deskripsi</Typography>
              <RuleDescription variant="body1" mt={2}>
                {data?.data[0].deskripsi_soal}
              </RuleDescription>
            </Box>
            <Box>
              <Typography fontWeight={700}>Perhatikan saat mengerjakan test!</Typography>
              <List>
                {!isLoading && data ? (
                  data.data.map((rule, idx) => (
                    <ListItem
                      key={idx}
                      sx={{
                        alignItems: 'flex-start',
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: 1,
                          mt: '6px',
                        }}
                      >
                        <CircleIcon
                          fontSize="small"
                          sx={{
                            width: '10px',
                            height: '10px',
                          }}
                        />
                      </ListItemIcon>
                      <RuleItem variant="body1">{rule.ketentuan_soal}</RuleItem>
                    </ListItem>
                  ))
                ) : (
                  <SkeletonLoading variant={'text'} length={3} />
                )}
              </List>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          p: 0,
          backgroundColor: 'transparent',
          position: 'fixed',
          bottom: '10px',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '444px',
        }}
      >
        {isLoading ? (
          <Box display={'flex'}>
            <SkeletonLoading
              length={1}
              sx={{
                width: '100px',
                height: '50px',
              }}
            />
          </Box>
        ) : (
          <React.Fragment>
            {checkDoneTask ? null : (
              <>
                {!safeCameraGranted || !safeLocationGranted ? (
                  <Button
                    variant="contained"
                    onClick={() => {
                      requestCameraPermission()
                      requestLocation()
                    }}
                    sx={{
                      width: '100%',
                      maxWidth: '200px',
                      fontWeight: 700,
                      color: 'white',
                      backgroundColor: ({ palette }) =>
                        palette[moduleType[modules.tipe_modul]]['light'],
                      // opacity: 0.5,
                      cursor: 'not-allowed',
                    }}
                  >
                    Izinkan Kamera & Lokasi
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (isIST && !isDobValid(currentDob)) {
                        setShowDobModal(true)
                        return
                      }
                      setShowWarning(true)
                    }}
                    sx={{
                      width: '100%',
                      maxWidth: '200px',
                      fontWeight: 700,
                      color: 'white',
                      backgroundColor: ({ palette }) =>
                        palette[moduleType[modules.tipe_modul]]['light'],
                    }}
                  >
                    Mulai
                  </Button>
                )}

                <Dialog open={showModal} onClose={() => setShowModal(false)}>
                  <DialogContent>
                    Harap izinkan kamera dan lokasi terlebih dahulu untuk memulai tes.
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setShowModal(false)}>Tutup</Button>
                  </DialogActions>
                </Dialog>

                {isIST && (
                  <DobModal
                    open={showDobModal}
                    userId={user?.id}
                    initialDob={currentDob}
                    onSuccess={handleDobSuccess}
                  />
                )}

                <Dialog
                  open={showWarning}
                  onClose={() => setShowWarning(false)}
                  fullWidth
                  maxWidth="xs"
                >
                  <DialogContent sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="h6" fontWeight={700} mb={2}>
                      ⚠️ Perhatian!
                    </Typography>
                    <Typography variant="body1" mb={2} textAlign="justify">
                      Segala bentuk kecurangan <em>(berpindah tab, screenshot, dan sebagainya)</em>{' '}
                      akan <strong>terdeteksi dan terekam oleh sistem</strong>.
                      <br />
                      Diharapkan untuk tidak melakukan atau mencoba tindakan tersebut selama ujian
                      berlangsung.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Klik "Saya Mengerti" untuk melanjutkan ke tes.
                    </Typography>
                  </DialogContent>
                  <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                    <Button
                      variant="contained"
                      disabled={!canProceed}
                      onClick={() => {
                        localStorage.setItem('audioUnlockedIntent', 'true')
                        setShowWarning(false)
                        beginQuestion()
                      }}
                      sx={{
                        fontWeight: 700,
                        color: 'white',
                        backgroundColor: ({ palette }) =>
                          palette[moduleType[modules.tipe_modul]]['light'],
                        opacity: canProceed ? 1 : 0.6,
                      }}
                    >
                      {canProceed ? 'Saya Mengerti' : 'Harap Tunggu...'}
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )}
          </React.Fragment>
        )}
      </Box>

      <Snackbar
        open={dobAlert.open}
        autoHideDuration={4000}
        onClose={() => setDobAlert((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ zIndex: 99999 }}
      >
        <Alert
          onClose={() => setDobAlert((prev) => ({ ...prev, open: false }))}
          severity={dobAlert.severity}
          variant="filled"
          sx={{ width: '100%', borderRadius: '10px', boxShadow: 3, fontWeight: 600 }}
        >
          {dobAlert.message}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default RulesPage
